export default __webpack_public_path__ + "static/media/CaennaVillageMap.2834264f.jpg";